<template>
  <div class="home">
    <template>
      <b-container class="container-rda">
        <b-row>
          <b-col>
            <Breadcrumb :breadcrumb="breadcrumb" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h2 class="purple bold">Painel de Avaliações</h2>
          </b-col>
          <b-col
            class="d-flex justify-content-end export-buttons-group"
            style="gap: 15px"
          >
            <b-button
              v-if="(canEdit || isTeacher) && !showOldFilters"
              md="4"
              lg="4"
              class="btn blue export-btn"
              :disabled="
                !students || !students.length || isLoading || !this.cycle
              "
              @click="downloadStudentPercentageReport"
            >
              {{
                !isLoading ? "Exportar evolução dos alunos" : "Carregando..."
              }}
            </b-button>

            <b-button
              v-if="canAccessRegisterReport"
              md="5"
              lg="5"
              class="btn blue export-btn"
              :disabled="
                !students ||
                !students.length ||
                isLoadingStudentEvaluationReport ||
                (!cycle_select && !this.subject) ||
                (!filter.subject && !this.subject)
              "
              @click="downloadStudentRegister(null)"
            >
              {{
                !isLoadingStudentEvaluationReport
                  ? "Exportar registros dos alunos"
                  : "Carregando..."
              }}
            </b-button>
          </b-col>
        </b-row>
        <div style="position: relative; z-index: 10">
          <b-row class="mt-50" align-v="start">
            <b-col
              md="2"
              class="d-flex align-items-center"
              :class="{
                'switch-pink': !showOldFilters,
                'switch-green': showOldFilters,
              }"
              style="padding-top: 28px"
            >
              <span
                :class="{
                  'font-weight-bold': !showOldFilters,
                  'text-muted': showOldFilters,
                }"
                class="mr-1"
                >Ciclo Atual</span
              >
              <b-form-checkbox
                v-model="showOldFilters"
                switch
                @change="toggleOldFilters"
              />
              <span
                :class="{
                  'font-weight-bold': showOldFilters,
                  'text-muted': !showOldFilters,
                }"
                class="ml-1"
                >Ciclos Anteriores</span
              >
            </b-col>

            <template v-if="!showOldFilters">
              <b-col>
                <SelectCycles
                  v-model="cycle"
                  :callback="callbackCycles"
                  :selected="cycle_select"
                ></SelectCycles>
                <span class="clear-field" @click="clearCycles"
                  >Limpar filtro</span
                >
              </b-col>
              <b-col>
                <b-form-group label="Área do conhecimento">
                  <div style="min-width: 260px; max-width: 100%">
                    <multiselect
                      v-model="selectedSubjectOption"
                      :options="subjectsOptions"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :disabled="!cycle_select"
                      placeholder="Selecione"
                      label="text"
                      track-by="value"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      style="min-width: 260px; max-width: 100%"
                    >
                      <span slot="noResult">Nada encontrado</span>
                    </multiselect>
                  </div>
                  <span
                    class="clear-field"
                    @click="clearSubjects"
                    v-if="filter.subject"
                    >Limpar filtro</span
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <SelectClassrooms
                  v-model="classroom"
                  :callback="callbackClassrooms"
                  :cycle="cycle_select"
                  :selected="classroom"
                />
                <span
                  class="clear-field"
                  v-if="classroom != null"
                  @click="clearClassromms"
                  >Limpar filtro</span
                >
              </b-col>
              <b-col>
                <SelectStudentsStatus
                  v-model="is_active"
                  :callback="callbackStudentsStatus"
                  :selected="is_active"
                />
                <span
                  class="clear-field"
                  v-if="is_active != null"
                  @click="clearStudentsStatus"
                  >Limpar filtro</span
                >
              </b-col>
              <b-col style="padding-right: 0">
                <b-form-group label="Buscar aluno">
                  <b-form-input
                    type="search"
                    size="sm"
                    placeholder="Digite aqui"
                    v-model="search"
                    @change="searchStudent"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </template>

            <template v-else>
              <b-col md="2">
                <div v-if="loadingVersions" class="spinner-container">
                  <b-spinner small></b-spinner>
                  <span class="ml-2">Carregando versões...</span>
                </div>
                <SelectSimple
                  v-else-if="versionOptions.length"
                  v-model="selectedVersion"
                  :options="versionOptions"
                  :callback="selectVersion"
                  label="Versão do currículo"
                />
              </b-col>

              <b-col md="3" v-if="selectedVersion">
                <div v-if="loadingCyclesOld" class="spinner-container">
                  <b-spinner small></b-spinner>
                  <span class="ml-2">Carregando ciclos...</span>
                </div>
                <SelectSimple
                  v-else-if="allCyclesOld.length"
                  v-model="selectedCycleOld"
                  label="Ciclo"
                  :options="allCyclesOld"
                  :callback="selectCycleOld"
                />
                <div v-if="selectedCycleOld && !loadingCyclesOld">
                  <span class="clear-field" @click="clearSubjectOld"
                    >Limpar filtro</span
                  >
                </div>
              </b-col>

              <b-col
                md="3"
                v-if="
                  selectedCycleOld &&
                  !loadingSubjectsOld &&
                  listSubjectsOld.length > 0
                "
              >
                <SelectSimple
                  v-model="selectedDisciplinaryOld"
                  label="Área do conhecimento"
                  :options="listSubjectsOld"
                  :callback="selectDisciplinaryOld"
                />
              </b-col>

              <b-col md="2" v-if="selectedCycleOld">
                <div v-if="loadingClassroomsOld" class="spinner-container">
                  <b-spinner small></b-spinner>
                  <span class="ml-2">Carregando turmas...</span>
                </div>
                <b-form-group v-else label="Turma atual">
                  <multiselect
                    v-model="classroomsSelAuxOld"
                    :options="classroomsSelOld"
                    :multiple="true"
                    placeholder="Selecione"
                    label="designation"
                    track-by="id"
                    selectLabel=""
                    @select="callbackClassroomsOld"
                    @remove="callbackRemoveClassroomsOld"
                    :disabled="classroomsSelOld.length === 0"
                  >
                    <span slot="noResult">Nada encontrado</span>
                  </multiselect>
                </b-form-group>
                <span
                  v-if="classroomsSelAuxOld.length > 0 && !loadingClassroomsOld"
                  class="clear-field"
                  @click="clearFieldsOld"
                  >Limpar filtros</span
                >
              </b-col>

              <b-col md="3" v-else-if="selectedCycleOld && loadingSubjectsOld">
                <div class="spinner-container">
                  <b-spinner small></b-spinner>
                  <span class="ml-2">Carregando áreas do conhecimento...</span>
                </div>
              </b-col>
            </template>
          </b-row>
        </div>

        <b-row>
          <b-col>
            <b-container fluid style="padding: 0">
              <div v-if="loadingStudents" class="spinner-container py-4">
                <b-spinner small></b-spinner>
                <span class="ml-2">Carregando alunos...</span>
              </div>
              <template v-else>
                <DataTable
                  class="list-top"
                  :items="students"
                  :fields="studentFields"
                  :busy="loadingStudents"
                  :primary-key="'id'"
                  empty-text="Nenhum aluno encontrado"
                >
                  <template #cell(cycle_name)="{ item }">
                    <p class="tags">{{ item.cycle_name }}</p>
                  </template>
                  <template #cell(classroom_designation)="{ item }">
                    <p class="tags">{{ item.classroom_designation }}</p>
                  </template>
                </DataTable>
                <b-row class="align-center" v-if="!search && wasRequestMade">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="count"
                    aria-controls="studentsList"
                    last-text
                    first-text
                  >
                    <template #prev-text>
                      <LeftArrowIcon class="left" />
                    </template>
                    <template #next-text>
                      <LeftArrowIcon />
                    </template>
                  </b-pagination>
                </b-row>
              </template>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>
import SelectClassrooms from "@/components/inputs/SelectClassrooms.vue";
import SelectCycles from "@/components/inputs/SelectCycles.vue";
import SelectSimple from "@/components/inputs/SelectSimple.vue";
import SelectStudentsStatus from "@/components/inputs/SelectStudentsStatus.vue";
import LeftArrowIcon from "@/components/svg/LeftArrowIcon.vue";
import DataTable from "@/components/table/DataTable.vue";
import moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex";
import HttpRda from "../../http-rda";
import DataServiceClassrooms from "@/services/classrooms.service";

export default {
  name: "painel-de-avaliacoes",
  components: {
    LeftArrowIcon,
    SelectClassrooms,
    SelectCycles,
    SelectSimple,
    SelectStudentsStatus,
    DataTable,
  },
  data() {
    return {
      showFloatingHeader: false,
      originalHeaderPosition: 0,
      wasRequestMade: false,
      search: "",
      filter: {
        subject: null,
      },
      cycle_select: null,
      cycle: null,
      calendar: null,
      classroom: null,
      is_active: true,
      students: [],
      currentPage: 1,
      count: 0,
      perPage: 10,
      isLoading: false,
      isLoadingStudentEvaluationReport: false,
      loadingStudents: false,
      subject: null,
      subjects: [],
      showOldFilters: false,

      versionOptions: [],
      selectedVersion: null,
      loadingVersions: false,
      allCyclesOld: [],
      selectedCycleOld: null,
      loadingCyclesOld: false,
      classroomsSelAuxOld: [],
      classroomsSelOld: [],
      selectedClassroomsSelOld: [],
      loadingClassroomsOld: false,
      listSubjectsOld: [],
      selectedDisciplinaryOld: null,
      loadingSubjectsOld: false,
      loadingStudentsOld: false,
      breadcrumb: [
        {
          text: "Aprendizagem",
          href: "/aprendizagem",
        },
        {
          text: "Painel de Avaliações",
          href: "/painel-de-avaliacoes",
          active: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/getAuthData",
    }),
    subjectsOptions() {
      return this.subjects.map((s) => ({
        value: s.subject_id,
        text: s.subject_designation,
      }));
    },
    selectedSubjectOption: {
      get() {
        return (
          this.subjectsOptions.find((s) => s.value == this.filter.subject) ||
          null
        );
      },
      set(option) {
        this.filter.subject = option ? option.value : null;
        this.currentPage = 1;
        if (!this.showOldFilters) {
          this.listStudents();
        }
      },
    },
    canEdit() {
      if (!this.user.role) {
        return false;
      }
      return ![
        "teacher",
        "student",
        "parent",
        "specialized_educational_support",
        "psychologist",
      ].includes(this.user.role[0]);
    },
    isTeacher() {
      if (!this.user.role) {
        return false;
      }
      return this.user.role.includes("teacher");
    },
    studentFields() {
      return [
        { key: "user_name", label: "Nome", tdClass: "nome" },
        {
          key: "cycle_name",
          label: "Ciclo",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "classroom_designation",
          label: "Turma",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ];
    },
    canAccessRegisterReport() {
      if (!this.user.role) {
        return false;
      }
      const allowedRoles = ["teacher", "coordinator", "admin"];
      return this.user.role.some((role) => allowedRoles.includes(role));
    },
  },
  methods: {
    ...mapActions({
      getStudent: "community/getStudent",
      deleteStudent: "community/deleteStudent",
      updateStatusStudents: "community/updateStatusStudents",
    }),
    onSubjectSelect(option) {
      this.filter.subject = option ? option.value : null;
    },
    async fetchSubjects() {
      const cycleId = this.cycle_select;
      if (!cycleId) {
        this.subjects = [];
        this.filter.subject = null;
        return;
      }
      try {
        const response = await HttpRda.get(
          `/subjects-select?cycleId=${cycleId}`
        );
        this.subjects = response.data.subjects || [];
      } catch (e) {
        this.subjects = [];
      }
    },
    clearSubjects() {
      this.filter.subject = null;
    },
    async downloadStudentRegister() {
      const url = `/student-report/evaluations`;
      try {
        this.isLoadingStudentEvaluationReport = true;
        const params = { ...this.filter };

        if (this.filter.subject) {
          params.subject = this.filter.subject;
        }

        if (this.showOldFilters) {
          if (this.selectedVersion) {
            params.version = this.selectedVersion.id;
          }
          if (this.selectedCycleOld) {
            params.cycleId = this.selectedCycleOld.id;
          }
          if (this.selectedClassroomsSelOld.length) {
            params.classrooms = this.selectedClassroomsSelOld;
          }
          if (this.subject) {
            params.subject = this.subject;
            params.previousCycle = true;
          }
        } else {
          if (this.cycle_select) {
            params.cycleId = this.cycle_select;
          }
        }

        const response = await HttpRda.get(url, {
          params,
          responseType: "blob",
        });

        if (response.status === 204) {
          this.$swal?.fire({
            icon: "info",
            title: "Sem dados para exportar",
            text: "Não foram encontrados registros de avaliação para os filtros selecionados.",
          });
          return;
        }

        const date = moment().format("DD-MM-YYYY-HH_mm_ss");
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        let fileName = `Relatorio_de_Registros_alunos_${date}.xlsx`;
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          const matches = contentDisposition.match(/filename="?(.+?)"?$/);
          if (matches && matches[1]) {
            fileName = matches[1].replace(/"/g, "");
          }
        }

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
          return;
        }

        const urlBlob = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlBlob;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          window.URL.revokeObjectURL(urlBlob);
        }, 500);

        this.$swal?.fire({
          icon: "success",
          title: "Relatório exportado com sucesso!",
        });
      } catch (error) {
        this.$swal?.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possível exportar o relatório!",
          footer: "Por favor, tente novamente mais tarde.",
        });
      } finally {
        this.isLoadingStudentEvaluationReport = false;
      }
    },
    async downloadStudentPercentageReport() {
      if (!this.cycle) {
        this.$swal &&
          this.$swal.fire({
            icon: "error",
            title: "Atenção!",
            text: "Por favor, selecione um ciclo antes de exportar o relatório.",
          });
        return;
      }
      let cycleName = this.students[0]?.cycle_name || "";
      if (cycleName) {
        cycleName = "_" + cycleName.replace(/ /g, "_").replace(/\./g, "");
      }
      const url = `/students/percentage_report?cycleId=${this.cycle}`;
      try {
        this.isLoading = true;
        const response = await HttpRda.get(url, {
          responseType: "blob",
        });
        const date = moment().format("DD-MM-YYYY-HH:mm:ss").toString();
        const newBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        let data = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = data;
        link.download = `Relatorio_de_Evolucao_alunos${
          cycleName ? cycleName : ""
        }_${date}`;
        link.click();
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100);
        this.$swal &&
          this.$swal.fire({
            icon: "success",
            title: `Relatório exportado com sucesso!`,
          });
        this.isLoading = false;
        return response;
      } catch (error) {
        this.isLoading = false;
        this.$swal &&
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel exportar o relatório!",
            footer: "Por favor, tente novamente mais tarde.",
          });
        return error;
      }
    },
    toggleOldFilters(show) {
      this.showOldFilters = show;
      this.students = [];
      this.count = 0;
      this.wasRequestMade = false;
      if (show) {
        this.calendar = null;
        this.cycle = null;
        this.cycle_select = null;
        this.classroom = null;
        this.is_active = true;
        this.search = "";
        this.subjects = [];
        this.filter.subject = null;
        this.currentPage = 1;
        this.getVersions();
      } else {
        this.selectedVersion = null;
        this.selectedCycleOld = null;
        this.classroomsSelAuxOld = [];
        this.selectedClassroomsSelOld = [];
        this.classroomsSelOld = [];
        this.listSubjectsOld = [];
        this.selectedDisciplinaryOld = null;
        this.subject = null;
        this.currentPage = 1;
        this.loadingStudents = true;
        this.fetchSubjects();
        this.listStudents();
      }
    },
    callbackCycles({ id }) {
      this.cycle = id !== -1 ? id : null;
      this.cycle_select = id;
      this.currentPage = 1;
      this.clearClassromms();
      this.fetchSubjects();
    },
    callbackClassrooms({ id }) {
      this.classroom = id !== -1 ? id : null;
      this.currentPage = 1;
      this.listStudents();
    },
    callbackStudentsStatus({ id }) {
      this.is_active = id !== null ? id : null;
      this.currentPage = 1;
      this.listStudents();
    },
    callbackCalendars({ id }) {
      this.calendar = id !== -1 ? id : null;
      this.currentPage = 1;
      this.listStudents();
    },
    async listStudents(page = 1) {
      if (this.showOldFilters) {
        await this.listStudentsOld(page);
        return;
      }

      this.loadingStudents = true;

      const params = {
        page,
        search: this.search,
        cycle: this.cycle,
        is_active: this.is_active,
        classroom: this.classroom,
        calendar: this.calendar,
        subject: this.filter.subject,
      };
      Object.keys(params).forEach(
        (key) =>
          (params[key] == null || params[key] === "") && delete params[key]
      );

      const currentQuery = this.$route.query;
      const queryChanged =
        JSON.stringify(currentQuery) !==
        JSON.stringify({ ...params, limit: this.perPage });

      if (queryChanged && this.$router) {
        try {
          await this.$router.replace({
            query: { ...params, limit: this.perPage },
          });
        } catch (err) {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        }
      }

      this.filter = {
        ...this.filter,
        ...params,
      };

      delete this.filter.limit;
      delete this.filter.page;

      await HttpRda.get("/students-community", { params })
        .then((res) => {
          this.students = res.data.students;
          this.count = res.data.count;
          this.wasRequestMade = true;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingStudents = false;
        });
    },
    async listStudentsOld(page = 1) {
      if (!this.selectedCycleOld || !this.selectedDisciplinaryOld) {
        this.students = [];
        this.count = 0;
        return;
      }

      this.loadingStudents = true;
      this.loadingStudentsOld = true;
      try {
        const params = {
          oldRecords: 1,
          page,
        };

        if (this.selectedVersion) {
          params.version = this.selectedVersion.id;
        }

        if (this.selectedClassroomsSelOld.length > 0) {
          params.classrooms = this.selectedClassroomsSelOld;
        }

        if (this.selectedCycleOld) {
          params.cycleId = this.selectedCycleOld.id;
          params.futureCycles = true;
        }

        const response = await HttpRda.get(
          `tutoring-old-curriculum/subjects/${this.subject}/students`,
          { params }
        );

        const students = response.data.result.data.map((student) => ({
          id: student.id,
          user_name: student.name,
          cycle_name: student.cycle_name,
          classroom_designation: student.classroom_designation,
        }));

        this.students = students;
        this.count = response.data.result.total || students.length;
        this.wasRequestMade = true;
      } catch (error) {
        this.students = [];
        this.count = 0;
        this.wasRequestMade = false;
      } finally {
        this.loadingStudents = false;
        this.loadingStudentsOld = false;
      }
    },
    async getVersions() {
      this.loadingVersions = true;
      try {
        const response = await HttpRda.get("/tutoring-old-curriculum/versions");
        this.versionOptions = response.data.result.map((version) => ({
          id: version.id,
          label: version.label,
        }));
      } catch (error) {
        this.versionOptions = [];
      } finally {
        this.loadingVersions = false;
      }
    },
    selectVersion(value) {
      this.selectedVersion = value;
      this.selectedCycleOld = null;
      this.classroomsSelAuxOld = [];
      this.selectedClassroomsSelOld = [];
      this.listSubjectsOld = [];
      this.selectedDisciplinaryOld = null;
      this.students = [];
      this.getCyclesOld();
    },
    async getCyclesOld() {
      if (!this.selectedVersion) {
        this.allCyclesOld = [];
        this.selectedCycleOld = null;
        return;
      }

      this.loadingCyclesOld = true;
      try {
        const cycles = await HttpRda.get(
          `tutoring-old-curriculum/cycles?version=${this.selectedVersion.id}&allCycles=true`
        );
        const filter = cycles.data.result.map((item) => {
          item.label = item.designation;
          delete item.designation;
          return item;
        });
        this.allCyclesOld = filter;
      } catch (error) {
        this.allCyclesOld = [];
      } finally {
        this.loadingCyclesOld = false;
      }
    },
    async selectCycleOld(params) {
      this.selectedClassroomsSelOld = [];
      this.classroomsSelAuxOld = [];
      this.listSubjectsOld = [];
      this.selectedCycleOld = params;
      this.students = [];
      this.count = 0;
      this.wasRequestMade = false;
      this.loadingSubjectsOld = true;

      const queryParams = {};

      if (this.selectedVersion) {
        queryParams.version = this.selectedVersion.id;
      }

      try {
        await this.getClassroomsOld(this.selectedCycleOld.id);

        let response = await HttpRda.get(
          `tutoring-old-curriculum/cycles/${params.id}/subjects`,
          { params: queryParams }
        );

        let subjects = response.data.result;

        subjects = subjects
          .map((item) => {
            item.label = item.designation;
            delete item.designation;
            return item;
          })
          .sort((a, b) => a.label.localeCompare(b.label));

        this.listSubjectsOld = subjects;

        this.selectedDisciplinaryOld = null;

        if (subjects.length === 0) {
          this.students = [];
          this.subject = null;
        }
      } finally {
        this.loadingSubjectsOld = false;
      }
    },
    getClassroomsOld(cycleId = null) {
      this.loadingClassroomsOld = true;
      DataServiceClassrooms.index({
        yearsback: 0,
        cycleId: cycleId,
        oldRecords: 1,
        futureCycles: true,
      })
        .then((response) => {
          this.classroomsSelOld = response.data.classrooms;
          if (this.classroomsSelOld.length) {
            this.classroomsSelOld = this.classroomsSelOld.map((classroom) => {
              return {
                id: classroom.id,
                designation: classroom.designation,
                calendar_id: classroom.calendar_id,
              };
            });
          }
        })
        .catch((error) => {
          return error.data;
        })
        .finally(() => {
          this.loadingClassroomsOld = false;
        });
    },
    async callbackClassroomsOld({ id }) {
      this.selectedClassroomsSelOld.push(id);
      await this.listStudentsOld();
    },
    async callbackRemoveClassroomsOld({ id }) {
      this.selectedClassroomsSelOld = this.selectedClassroomsSelOld.filter(
        (classroom) => classroom !== id
      );
      await this.listStudentsOld();
    },
    async selectDisciplinaryOld(params) {
      this.selectedDisciplinaryOld = params;
      this.subject = params.id;
      await this.listStudentsOld();
    },
    clearSubjectOld() {
      this.selectedCycleOld = null;
      this.classroomsSelAuxOld = [];
      this.selectedClassroomsSelOld = [];
      this.listSubjectsOld = [];
      this.selectedDisciplinaryOld = null;
      this.students = [];
      this.subject = null;
    },
    clearFieldsOld() {
      this.classroomsSelAuxOld = [];
      this.selectedClassroomsSelOld = [];
      this.listStudentsOld();
    },
    async searchStudent() {
      if (!this.search) {
        this.clearFields();
        return;
      }
      this.currentPage = 1;
      this.listStudents();
    },
    clearFields() {
      this.search = "";
      this.clearCycles();
      this.is_active = true;
      this.currentPage = 1;
      this.listStudents();
    },
    clearCycles() {
      this.cycle = null;
      this.cycle_select = null;
      this.currentPage = 1;
      this.clearClassromms();
      this.listStudents();
    },
    clearCalendar() {
      this.calendar = null;
      this.currentPage = 1;
      this.listStudents();
    },
    clearClassromms() {
      this.classroom = null;
      this.currentPage = 1;
      this.listStudents();
    },
    clearStudentsStatus() {
      this.is_active = null;
      this.currentPage = 1;
      this.listStudents();
    },
  },
  watch: {
    async cycle_select(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      this.filter.subject = null;

      await this.fetchSubjects();

      if (!this.showOldFilters) {
        await this.listStudents();
      }
    },

    currentPage() {
      this.listStudents(this.currentPage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    "filter.subject"(newVal) {
      if (newVal !== null && !this.showOldFilters) {
        this.currentPage = 1;
        this.listStudents();
      }
    },
  },
  async created() {
    const query = this.$route.query || {};
    this.perPage = Number(query.limit) || 10;
    this.search = query.search || "";
    this.cycle = query.cycle ? Number(query.cycle) : null;
    this.cycle_select = query.cycle ? Number(query.cycle) : null;
    this.is_active =
      query.is_active === undefined || query.is_active === null
        ? true
        : query.is_active === "true";
    this.classroom = query.classroom ? Number(query.classroom) : null;
    this.calendar = query.calendar ? Number(query.calendar) : null;

    if (this.cycle_select) {
      await this.fetchSubjects();
    }

    if (!this.showOldFilters) {
      await this.listStudents(this.currentPage);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.list-top {
  margin-top: 30px;
  margin-bottom: 30px;
}

.div-zero-left {
  padding-left: 0 !important;
}

.outline {
  color: #fff !important;
  background: transparent;
  max-width: 220px !important;
  margin-right: 20px;

  &:hover {
    color: #68c5b7 !important;
  }
}

.actions-buttons {
  display: flex;
  gap: 15px;
}

::v-deep .tags {
  display: inline-block;
  background-color: $blue;
  border-radius: 5px;
  color: $white;
  font-weight: $bold;
  line-height: 28px;
  padding: 0 8px;
  text-align: center;
  vertical-align: middle;
  max-width: 125px;
  margin: 0;
}

::v-deep td.nome {
  font-size: 18px !important;
  font-weight: normal !important;
}

.text-center {
  text-align: center !important;
}

.text-left {
  text-align: left !important;
}

.export-buttons-group .export-btn {
  min-width: 300px;
}

.switch-pink {
  ::v-deep .custom-switch .custom-control-label::before,
  ::v-deep .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #b23066;
    border-color: #b23066;
  }
  ::v-deep .custom-switch .custom-control-label::after,
  ::v-deep .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    background-color: #fff;
  }
}
.switch-green {
  ::v-deep .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #68c5b7 !important;
    border-color: #68c5b7 !important;
  }
}

.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 82px;
  padding: 10px 15px;
  color: #6c757d;
}
</style>
